module.exports = __webpack_public_path__ + "img/Spro Deal-i@2x.8447db7c.png";